import React, { useState, useCallback, useMemo, useEffect } from "react";
import FilterSelect from "./FilterSelect";
import FilterAuto from "./FilterAuto";
import FilterDate from "./FilterDate";

export default function FiltersForm({ config, onChange }) {
  /* ---------- 1. derive initial state from config ---------- */
  const initialState = useMemo(
    () =>
      Object.fromEntries(
        config.map(({ param, default: d = "" }) => [param, d])
      ),
    [config]
  );

  const [values, setValues] = useState(initialState);

  /* If config defaults change (URL rewrite), reset form state */
  useEffect(() => setValues(initialState), [initialState]);

  /* ---------- 2. field updater ---------- */
  const handleUpdate = useCallback(
    (key, val) => {
      onChange((prev) => ({
        ...prev,
        [key]: val,
      }));
    },
    [onChange]
  );

  /* ---------- 3. renderer ---------- */
  const render = (f) => {
    const shared = {
      key: f.param,
      name: f.param,
      label: f.label,
      width: f.width,
      value: values[f.param],
      onChange: handleUpdate,
      multiple: f.multi,
    };
    switch (f.type) {
      case "select":
        return <FilterSelect {...shared} options={f.options} />;
      case "auto":
        return <FilterAuto {...shared} options={f.options} />;
      case "date":
        return <FilterDate {...shared} />;
      default:
        return null;
    }
  };

  return (
    <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
      {config.map(render)}
    </div>
  );
}
